// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Mar8BQBHa1ldPnl","lock":"_2at5Ka5Dm0AzS-qp","title":"dQ8RjUcfhyvrKaj0","block":"_26hI1Lya_ryrwQFT","subHeading":"_10tsEjEZR5LCVQEW","subTitle":"lJiDn8Nywh85eoAj"};